import Vue from 'vue';

Vue.component('car-comparison-component-v2', {
    props: {
        allCarVariants: {
            type: Array,
        },
    },

    data() {
        return {
            compareCars: [],
            showAllSpecs: false,
            activeModelSelection: null,
            isTransitioning: false,
        };
    },

    mounted() {
        console.log({ allCarVariants: this.allCarVariants });
        if (this.allCarVariants[0].editions[0]) {
            this.compareCars.push(
                this.getCompareCarWithoutSelectingSpecificModel(
                    this.allCarVariants[0],
                ),
            );
        }

        if (this.allCarVariants[1].editions[0]) {
            this.compareCars.push(
                this.getCompareCarWithoutSelectingSpecificModel(
                    this.allCarVariants[1],
                ),
            );
        }
    },

    watch: {
        // This prevents scroll reset immediately after the dropdown closes to fix a "glitch" where scroll resets
        // before vue transition finishes
        activeModelSelection(newScrollValue, oldScrollValue) {
            if (oldScrollValue === null && newScrollValue !== null) return;

            setTimeout(() => {
                const scrollArea = this.$refs['scrollArea' + oldScrollValue];

                if (scrollArea && scrollArea[0]) {
                    scrollArea[0].style.overflowY = 'auto';
                    scrollArea[0].style.pointerEvents = 'auto';
                    scrollArea[0].scrollTop = 0;
                }

                this.isTransitioning = false;
            }, 350);
        },
    },

    methods: {
        getCompareCarWithoutSelectingSpecificModel(car) {
            return {
                modelTitle: car.modelName,
                compareLabelText: car.versionTitle,
                compareLabelColor: car.colorCode,
                modelImage: car.editions[0].image?.url,
                editionName: car.editions[0].title,
                versionIcon: car.versionIcon.url,
                specifications: car.editions[0].specificationValues,
                linkBuilder: car.editions[0].linkBuilder,
            };
        },

        getCompareCar(modelName, editionName) {
            const parentCar = this.allCarVariants.find(
                (car) => car.modelName === modelName,
            );
            const carEdition = parentCar.editions.find(
                (child) => child.title === editionName,
            );

            return {
                modelTitle: parentCar.modelName,
                compareLabelText: parentCar.versionTitle,
                compareLabelColor: parentCar.colorCode,
                modelImage: carEdition.image?.url,
                editionName: carEdition.title,
                versionIcon: parentCar.versionIcon.url,
                specifications: carEdition.specificationValues,
                linkBuilder: carEdition.linkBuilder,
            };
        },

        getProduct(productId) {
            for (let i = 0; i < this.allCarVariants.length; i++) {
                if (this.allCarVariants[i].id === productId) {
                    return this.allCarVariants[i];
                }
            }
            return null;
        },

        toggleSpecs() {
            this.showAllSpecs = !this.showAllSpecs;
        },

        persistScrollDistance(index) {
            const scrollArea = this.$refs['scrollArea' + index];

            if (!scrollArea[0]) return;
            const currentScrollTop = scrollArea[0].scrollTop;

            this.isTransitioning = true;

            scrollArea[0].style.overflowY = 'hidden';
            scrollArea[0].style.pointerEvents = 'none';
            scrollArea[0].scrollTop = currentScrollTop;
        },

        toggleModelSelection(compareCarIndex) {
            const activeModelSelectionExists =
                this.activeModelSelection !== null;
            const isActiveModelSelectionEqualToCompareCarIndex =
                activeModelSelectionExists &&
                compareCarIndex === this.activeModelSelection;

            if (isActiveModelSelectionEqualToCompareCarIndex) {
                this.persistScrollDistance(compareCarIndex);
                this.activeModelSelection = null;
                return;
            }

            this.activeModelSelection = compareCarIndex;

            this.$nextTick(() => {
                this.initScrollbar(compareCarIndex);
            });
        },

        removeCar(compareCarIndex) {
            this.compareCars.splice(compareCarIndex, 1);
        },

        updateCar(compareCarIndex, modelName, editionName) {
            const newCar = this.getCompareCar(modelName, editionName);
            const cars = this.compareCars;

            if (!newCar) return;
            this.persistScrollDistance(compareCarIndex);

            cars[compareCarIndex] = newCar;
            this.compareCars = [...cars];
            this.activeModelSelection = null;
        },

        addCar() {
            if (this.allCarVariants[2]) {
                this.compareCars.push(
                    this.getCompareCarWithoutSelectingSpecificModel(
                        this.allCarVariants[2],
                    ),
                );
            } else {
                this.compareCars.push(
                    this.getCompareCarWithoutSelectingSpecificModel(
                        this.allCarVariants[0],
                    ),
                );
            }
        },

        getCarWithVersionIcon(model, versionLabelText) {
            let versionIconName = '';
            switch (versionLabelText) {
                case 'Electric':
                case 'Électrique':
                    versionIconName = 'electric-icon';
                    break;
                case 'Plug-In Hybrid':
                    versionIconName = 'hybrid-icon';
                    break;
                case 'Hybrid':
                    versionIconName = 'hev-icon';
                    break;
                case 'Petrol':
                    versionIconName = 'petrol-icon';
                    break;
            }

            model.versionIconName = versionIconName;
            return model;
        },

        getDropdownActiveStateClass(index, modelName, editionName) {
            const parentCar = this.allCarVariants.find(
                (car) => car.modelName === modelName,
            );
            const carEdition = parentCar.editions.find(
                (child) => child.title === editionName,
            );

            return this.compareCars[index].modelTitle !== parentCar.modelName ||
                this.compareCars[index].editionName !== carEdition.title
                ? ''
                : 'comparison__model-selection-model-variants-variant--active';
        },

        handleComparisonScroll(carIndex, e) {
            const scrollArea = e.target;
            const scrollBar = this.$refs['scrollBar' + carIndex];
            const scrollTrack = this.$refs['scrollTrack' + carIndex];

            if (!scrollArea || !scrollBar || !scrollTrack) return;

            const scrollBarElement = scrollBar[0];
            const scrollTrackElement = scrollTrack[0];

            if (!scrollBarElement || !scrollTrackElement) return;

            const scrollTop = scrollArea.scrollTop;
            const scrollHeight = scrollArea.scrollHeight;
            const clientHeight = scrollArea.clientHeight;
            const maxScroll = scrollHeight - clientHeight;

            const scrollPercentage = scrollTop / maxScroll;
            const trackHeight = scrollTrackElement.clientHeight;
            const barHeight = scrollBarElement.clientHeight;
            const maxTop = trackHeight - barHeight;

            const thumbTop = scrollPercentage * maxTop;
            scrollBarElement.style.top = thumbTop + 'px';
        },

        initScrollbar(carIndex) {
            const scrollArea = this.$refs['scrollArea' + carIndex];
            const scrollTrack = this.$refs['scrollTrack' + carIndex];
            const scrollBar = this.$refs['scrollBar' + carIndex];

            if (!scrollArea || !scrollTrack || !scrollBar) return;

            const scrollAreaElement = scrollArea[0];
            const scrollTrackElement = scrollTrack[0];
            const scrollBarElement = scrollBar[0];

            if (!scrollAreaElement || !scrollTrackElement || !scrollBarElement)
                return;

            if (!this.isTransitioning) {
                scrollAreaElement.scrollTop = 0;
            }

            const scrollRatio =
                scrollAreaElement.clientHeight / scrollAreaElement.scrollHeight;
            const thumbHeight = scrollRatio * scrollTrackElement.clientHeight;

            scrollBarElement.style.height = thumbHeight + 'px';
            scrollBarElement.style.top = '0px';
        },
    },
});
